import * as Backbone from "backbone";
import {DashboardWidgetCollection} from "../../../collections/DashboardWidgets";
import {DashboardChannelCollection} from "../../../collections/DashboardChannels";
import {PermissionCollection} from "../../../collections/Permissions";
import {ModuleCollection} from "../../../collections/Modules";
import {User} from "../../../models/User";
import {DashboardWidget} from "../../../models/DashboardWidget";
import {ChartWorkerManager} from "./ChartWorkerManager";
import {BaseView} from "../../_BaseViews";
import * as $ from "jquery";

declare var App: any;

export interface BaseDashboardWidgetViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    dashboardWidgetCollection: DashboardWidgetCollection,
    dashboardChannelCollection: DashboardChannelCollection,
    permissionCollection: PermissionCollection,
    moduleCollections?: { [key: number]: ModuleCollection },
    parentView: Backbone.View<Backbone.Model>,
    widget: DashboardWidget,
    manager: any,
    chartWorkerManager?: ChartWorkerManager;
    dashboardId: number;
    categoryId: number;
    widgetId: number;
    currentUser: User;
    editable: boolean;
    movable: boolean;
    cloneable: boolean;
    deletable: boolean;
    report?: Backbone.Model;
}


export class BaseDashboardWidgetView extends BaseView {

    options: BaseDashboardWidgetViewOptions;

    constructor(options: BaseDashboardWidgetViewOptions) {
        super(options);
    };

    protected handleRemoveWidgetClick() {
        this.$('.w-delete-widget-wrapper').removeClass('hidden');
    }

    protected handleRemoveWidgetCancelClick() {
        this.$('.w-delete-widget-wrapper').addClass('hidden');
    }

    protected handleRemoveWidgetConfirmClick() {
        App.Bus.trigger('dashboard:update:suspend');
        $.when(this.options.widget.destroy())
            .then(() => {
                return this.options.dashboardWidgetCollection.getCollectionFetchPromise()
            })
            .then(() => {
                return this.options.dashboardChannelCollection.getCollectionFetchPromise()
            })
            .then(() => {
                this.remove();
                this.options.widget = null;
                App.Bus.trigger('dashboard:category:' + this.options.categoryId + ':layout');
                App.Bus.trigger('dashboard:config:changed');
                App.Bus.trigger('dashboard:update:resume');
            });
    }

    protected handleEditWidgetClick(eventTrigger) {
        this.options.manager.createModifyDashboardWidgetModal(this.options.widget);
    }

    protected handleCloneWidget(e: JQuery.UIEventBase) {
        var widgetId = Number($(e.currentTarget).parents('.widget').attr('data-widget-id'));
        var categoryId = Number($(e.currentTarget).parents('.category').attr('data-category-id'));
        var clonedWidgetId, widgetView;

        // Pause dashboard updates to prevent hiccups in the middle of our cloning operation
        App.Bus.trigger('dashboard:update:suspend');

        // Build URL with widget ID in path before query parameters
        var baseUrl = this.options.dashboardWidgetCollection.url();
        var queryIndex = baseUrl.indexOf('?');
        var cloneUrl: string;
        
        if (queryIndex !== -1) {
            // Insert widget ID before the query string
            cloneUrl = baseUrl.substring(0, queryIndex) + '/' + widgetId + '/clone' + baseUrl.substring(queryIndex);
        } else {
            // No query string, just append widget ID
            cloneUrl = baseUrl + '/' + widgetId + '/clone';
        }

        $.ajax({
            type: "POST",
            url: cloneUrl,
            data:  JSON.stringify({
                dashboard_category_id: categoryId,
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            complete: (res) => {
                clonedWidgetId = res.responseJSON.widgetId;
                $.when(
                    this.options.dashboardWidgetCollection.fetch(),
                    this.options.dashboardChannelCollection.fetch()
                )
                    .done(() => {
                        // Tell DashboardCategoryView to re-render the layout
                        App.Bus.trigger('dashboard:category:' + categoryId + ':layout');
                        // Update the dashboard config
                        App.Bus.trigger('dashboard:config:changed');
                        // Resume dashboard updates
                        App.Bus.trigger('dashboard:update:resume');

                        // The dashboard's refresh creates a timing issue here
                        setTimeout(() => {
                            // We get the cloned widget view from DashboardWidget Manager
                            widgetView = this.options.manager.getWidgetViewFromWidgetId(clonedWidgetId);
                            // To call this handy instance method that displays an edit dialogue
                            widgetView.handleEditWidgetClick();
                        }, 250);
                    });
            }
        });
    }

    hasNeededPermissions() {
        return true;
    }

    remove() {
        // Remove this widget view from widgetViews (if this widget wasn't deleted)
        if(this.options.manager && this.options.widget && this.options.widget.get('id')) {
            this.options.manager.removeWidgetView(this.options.widget.get('id'));
        }

        // Remove listeners from the global event bus
        this.stopListening();
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/dashboard/widgets/_BaseWidgetView.ts